
import { useStore } from "vuex";
import { defineComponent } from "vue";
// import GenericPanel from "../GenericPanel.vue";
import ServerStatus from "../ServerStatus.vue";

export default defineComponent({
  name: "NavMenuLeft",
  setup() {
    const store = useStore();
    const latestUpdate =
      store.state.system.versionLog[store.state.system.versionLog.length - 1];
    const title = "g.e.c.k. v" + latestUpdate.version;
    return {
      state: store.state,
      title,
    };
  },
  components: { ServerStatus },
});
